import { RouteRecordRaw } from "vue-router";

export const applications: RouteRecordRaw = {
  path: "/applications",
  component: () =>
    import(/* webpackChunkName: "applications" */ "@/layouts/Default.vue"),
  children: [
    {
      path: "list",
      name: "ApplicationsList",
      component: () =>
        import(
          /* webpackChunkName: "applications" */ "@/views/applications/ApplicationsList.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "detail/:applicationId",
      name: "ApplicationsDetail",
      component: () =>
        import(
          /* webpackChunkName: "applications" */ "@/views/applications/ApplicationsDetail.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "cancel/:applicationId",
      name: "ApplicationCancel",
      component: () =>
        import(
          /* webpackChunkName: "applications" */ "@/views/applications/Cancel.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "cancel-reason/:applicationId",
      name: "ApplicationCancelReason",
      component: () =>
        import(
          /* webpackChunkName: "applications" */ "@/views/applications/CancelReason.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "cancel-policy/:applicationId",
      name: "ApplicationCancelPolicy",
      component: () =>
        import(
          /* webpackChunkName: "applications" */ "@/views/applications/CancelPolicy.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "evaluation/:applicationId",
      name: "ApplicationEvaluation",
      component: () =>
        import(
          /* webpackChunkName: "applications" */ "@/views/applications/Evaluation.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "evaluation/:applicationId/desireToWork/:evaluationByWorkerId",
      name: "EvaluationDesireToWork",
      component: () =>
        import(
          /* webpackChunkName: "applications" */ "@/views/applications/EvaluationDesireToWork.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "evaluation/:applicationId/finished",
      name: "ApplicationEvaluationFinished",
      component: () =>
        import(
          /* webpackChunkName: "applications" */ "@/views/applications/EvaluationFinished.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "work-started/:applicationId",
      name: "WorkStarted",
      component: () =>
        import(
          /* webpackChunkName: "applications" */ "@/views/applications/WorkStarted.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "work-finished/:applicationId",
      name: "WorkFinished",
      component: () =>
        import(
          /* webpackChunkName: "applications" */ "@/views/applications/WorkFinished.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "attendance-correction/:applicationId",
      name: "AttendanceCorrection",
      component: () =>
        import(
          /* webpackChunkName: "applications" */ "@/views/applications/AttendanceCorrection.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "attendance-correction-confirmation/:applicationId",
      name: "AttendanceCorrectionConfirmation",
      component: () =>
        import(
          /* webpackChunkName: "applications" */ "@/views/applications/AttendanceCorrectionConfirmation.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "attendance-correction-detail/:applicationId",
      name: "AttendanceCorrectionDetail",
      component: () =>
        import(
          /* webpackChunkName: "applications" */ "@/views/applications/AttendanceCorrectionDetail.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "attendance-correction-finished/:applicationId",
      name: "AttendanceCorrectionFinished",
      component: () =>
        import(
          /* webpackChunkName: "applications" */ "@/views/applications/AttendanceCorrectionFinished.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "notice-of-employment/:applicationId",
      name: "NoticeOfEmploymentsList",
      component: () =>
        import(
          /* webpackChunkName: "applications" */ "@/views/applications/NoticeOfEmploymentsList.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    }
  ]
};

/**
 * QRスキャナの画面のみレイアウトが大きく変わるため、別ルーティングとしている
 */
export const qrApplications: RouteRecordRaw = {
  path: "/applications",
  component: () =>
    import(/* webpackChunkName: "applications" */ "@/layouts/Default.vue"),
  props: { isBackgroundTransparent: true },
  children: [
    {
      path: "qr-scanner",
      name: "QrScanner",
      component: () =>
        import(
          /* webpackChunkName: "applications" */ "@/views/applications/QrScanner.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "qr-scanner-web",
      name: "QrScannerWeb",
      component: () =>
        import(
          /* webpackChunkName: "applications" */ "@/views/applications/QrScannerWeb.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    }
  ]
};
